import { defineMessages } from 'react-intl';

export const messages: {
	uploadErrorTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	uploadErrorAttachmentLimitExceeded: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	uploadErrorTitle: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-start.upload-error-title',
		defaultMessage: 'Error uploading attachment',
		description: 'Title displayed in the error flag when an attachment upload error has occurred.',
	},
	uploadErrorAttachmentLimitExceeded: {
		id: 'proforma-form-renderer.ui.form-renderer.form-sections.form-section.form-extension-renderer.form-field-renderer.attachment-field.edit.utils.on-upload-start.upload-error-attachment-limit-exceeded',
		defaultMessage: `There can't be more than 50 attachments on a form at any given time.`,
		description:
			'Description displayed in the error flag when uploading an attachment would exceed the maximum number of attachments on a form (50).',
	},
});
